// slice 02.1 · paso b.6h — forma "línea" del canvas de roadmap (`ComponentTaskFlow.jsx`): solo
// mover, borrar y cambiar color. Presentacional puro — el container decide qué hacer al borrar
// (`onDelete`) y al cambiar color (`onColorChange`), por el boundary lint (no `fetch`/`toast`
// directo desde una hoja).

import { Trash2 } from 'lucide-react';
import { getSmoothPath } from '../lib/flowCanvas';

const TEXT_COLORS = ['#ffffff', '#000000', '#ef4444', '#3b82f6', '#22c55e', '#eab308', '#a855f7', '#ec4899'];

export default function FlowLineShape({ node, x, y, isMoving, isSelected, onMoveStart, onDelete, onColorChange }) {
    const strokeColor = node.colorToken || '#ffffff';

    return (
        <div className="roadmap-task-node" style={{ ...(isSelected ? { outline: '2px solid #0d99ff', outlineOffset: '2px' } : {}), position: 'absolute', left: x, top: y, zIndex: isMoving ? 50 : 20, width: node.w, height: node.h, pointerEvents: 'none' }} onPointerDown={onMoveStart} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()}>
            <svg width={node.w} height={node.h} style={{ overflow: 'visible', pointerEvents: 'none' }}>
                <path d={getSmoothPath(node.points)} fill="none" stroke={strokeColor} strokeWidth={4} strokeLinecap="round" strokeLinejoin="round" style={{ pointerEvents: 'stroke', cursor: isMoving ? 'grabbing' : 'grab' }} onPointerDown={e => { e.stopPropagation(); onMoveStart(e); }} />
            </svg>
            {/* Hover tools (Delete & Color) */}
            <div className="task-drag-handle" style={{ position: 'absolute', left: '-35px', top: '0', width: '35px', height: '100%', zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '8px', gap: '8px', pointerEvents: 'none' }}>
                {/* Delete Button */}
                <button onPointerDown={(e) => e.stopPropagation()} onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                }} style={{ background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.4)', color: '#ef4444', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', pointerEvents: 'auto' }}>
                    <Trash2 size={12} />
                </button>
                {/* Color Picker */}
                <div style={{ position: 'relative', pointerEvents: 'auto' }}>
                    <button onPointerDown={e => e.stopPropagation()} onClick={e => {
                        e.stopPropagation();
                        const menu = e.currentTarget.nextElementSibling;
                        menu.style.display = menu.style.display === 'none' ? 'flex' : 'none';
                    }} style={{ background: strokeColor, width: '18px', height: '18px', borderRadius: '50%', cursor: 'pointer', border: '1px solid rgba(255,255,255,0.4)', padding: 0 }} />

                    <div style={{ display: 'none', position: 'absolute', left: '-120px', top: '-10px', background: '#222', border: '1px solid #333', borderRadius: '8px', padding: '4px', gap: '4px', flexWrap: 'wrap', width: '110px', boxShadow: '0 2px 8px rgba(0,0,0,0.5)', zIndex: 100 }}>
                        {TEXT_COLORS.map(c => (
                            <button key={c} onPointerDown={e => e.stopPropagation()} onClick={e => {
                                e.stopPropagation();
                                e.currentTarget.parentElement.style.display = 'none';
                                onColorChange(c);
                            }} style={{ width: '16px', height: '16px', borderRadius: '50%', background: c, border: c === node.colorToken ? '2px solid #000' : 'none', cursor: 'pointer', padding: 0 }} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
